import React from 'react';
import { Mail, MapPin, Send } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-20 md:py-32 bg-white" data-id="element-27">
      <div className="container mx-auto px-4 md:px-6" data-id="element-28">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-29">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a4d5c] mb-4" data-id="element-30">
            Get in Touch
          </h2>
          <div className="w-20 h-1 bg-[#d4a017] mx-auto mb-6" data-id="element-31"></div>
          <p className="text-gray-600 text-lg" data-id="element-32">
            For inquiries regarding our trading services, please reach out to
            our team.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 max-w-6xl mx-auto" data-id="element-33">
          {/* Contact Info */}
          <div className="lg:col-span-1 space-y-8" data-id="element-34">
            <div className="bg-[#f9f9f7] p-8 rounded-xl" data-id="element-35">
              <h3 className="text-xl font-bold text-[#1a4d5c] mb-6" data-id="element-36">
                Contact Information
              </h3>

              <div className="space-y-6" data-id="element-37">
                <div className="flex items-start gap-4" data-id="element-38">
                  <div className="bg-[#1a4d5c] p-2 rounded-full text-white shrink-0" data-id="element-39">
                    <MapPin size={20} data-id="element-40" />
                  </div>
                  <div data-id="element-41">
                    <p className="font-medium text-[#1a4d5c]" data-id="element-42">Office</p>
                    <p className="text-gray-600" data-id="element-43">
                      10 Anson Road, #33-03
                      <br data-id="element-44" />
                      International Plaza
                      <br data-id="element-45" />
                      Singapore 079903
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-46">
                  <div className="bg-[#1a4d5c] p-2 rounded-full text-white shrink-0" data-id="element-47">
                    <Mail size={20} data-id="element-48" />
                  </div>
                  <div data-id="element-49">
                    <p className="font-medium text-[#1a4d5c]" data-id="element-50">Email</p>
                    <a href="mailto:info@manifoldtrade.com" className="text-gray-600 hover:text-[#d4a017] transition-colors" data-id="element-51">
                      info@manifoldtrade.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-2" data-id="element-52">
            <form className="bg-white rounded-xl shadow-lg p-8 border border-gray-100" data-id="element-53">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-54">
                <div data-id="element-55">
                  <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-56">
                    First Name
                  </label>
                  <input type="text" id="firstName" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#1a4d5c] focus:border-transparent outline-none transition-all" placeholder="John" data-id="element-57" />
                </div>
                <div data-id="element-58">
                  <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-59">
                    Last Name
                  </label>
                  <input type="text" id="lastName" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#1a4d5c] focus:border-transparent outline-none transition-all" placeholder="Doe" data-id="element-60" />
                </div>
              </div>

              <div className="mb-6" data-id="element-61">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-62">
                  Email Address
                </label>
                <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#1a4d5c] focus:border-transparent outline-none transition-all" placeholder="john@company.com" data-id="element-63" />
              </div>

              <div className="mb-6" data-id="element-64">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-65">
                  Subject
                </label>
                <select id="subject" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#1a4d5c] focus:border-transparent outline-none transition-all bg-white" data-id="element-66">
                  <option value="" data-id="element-67">Select a topic</option>
                  <option value="energy" data-id="element-68">Energy Trading</option>
                  <option value="automotive" data-id="element-69">Automotive & EV</option>
                  <option value="wholesale" data-id="element-70">Wholesale Trading</option>
                  <option value="general" data-id="element-71">General Inquiry</option>
                  <option value="other" data-id="element-72">Other</option>
                </select>
              </div>

              <div className="mb-8" data-id="element-73">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-74">
                  Message
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#1a4d5c] focus:border-transparent outline-none transition-all resize-none" placeholder="Your message" data-id="element-75"></textarea>
              </div>

              <button type="submit" className="w-full bg-[#1a4d5c] hover:bg-[#133a45] text-white font-bold py-4 rounded-lg transition-colors flex items-center justify-center gap-2" data-id="element-76">
                Send Message
                <Send size={18} data-id="element-77" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}